import { render, staticRenderFns } from "./Corp2FAToggle.vue?vue&type=template&id=445bffaa&scoped=true&"
import script from "./Corp2FAToggle.vue?vue&type=script&lang=js&"
export * from "./Corp2FAToggle.vue?vue&type=script&lang=js&"
import style0 from "./Corp2FAToggle.vue?vue&type=style&index=0&id=445bffaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445bffaa",
  null
  
)

export default component.exports